import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import CmsInlineEdit from '../../../components/Cms/CmsInlineEdit';

export default function Carousel({ images, cmsNode }) {
  const containerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    let animationFrame;
    const speed = 0.5; // Adjust speed here

    const move = () => {
      if (!isPaused) {
        container.scrollLeft += speed;

        // When first item fully leaves view, move it to end
        const first = container.children[0];
        const firstWidth = first.offsetWidth + 16; // + gap

        if (container.scrollLeft >= firstWidth) {
          container.appendChild(first);
          container.scrollLeft -= firstWidth;
        }
      }

      animationFrame = requestAnimationFrame(move);
    };

    animationFrame = requestAnimationFrame(move);

    return () => cancelAnimationFrame(animationFrame);
  }, [isPaused]);

  return (
    <div
      className="overflow-hidden w-full h-[280px] md:h-[392px] mx-auto relative flex gap-4"
      ref={containerRef}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={() => setIsPaused(true)}
      onTouchEnd={() => setIsPaused(false)}
      style={{
        whiteSpace: "nowrap",
        display: "flex",
        scrollBehavior: "auto",
      }}
    >
      {images.map((img, i) => (
        <CmsInlineEdit type="list" cmsNode={cmsNode || null} showContent={false} showChilds>
          <div
            key={i} // eslint-disable-line
            className="flex-shrink-0 w-[312px] h-[280px] md:w-[600px] md:h-[392px]"
          >
            <img
              src={img}
              alt=""
              className="object-cover rounded-2xl w-full h-full w-[312px] h-[280px] md:w-[600px] md:h-[392px]"
            />
          </div>
        </CmsInlineEdit>
      ))}
    </div>
  );
}

Carousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  cmsNode: PropTypes.shape({}).isRequired
};
